export const SET_SSO_PARAMETERS = 'SET_SSO_PARAMETERS'
